import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7066586f&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./index.sass?vue&type=style&index=0&id=7066586f&prod&scoped=true&lang=sass&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7066586f",
  null
  
)

export default component.exports